import Assets from 'app/configs/assetConfigs'
const { facebookIcon, linkedinIcon, instagramIcon, twitterIcon } = Assets

const getSocialMediaIconByType = (type) => {
  switch (type.toLowerCase()) {
    case 'facebook':
      return facebookIcon
    case 'linkedin':
      return linkedinIcon
    case 'twitter':
      return twitterIcon
    case 'instagram':
      return instagramIcon
    default:
      return null
  }
}

export default getSocialMediaIconByType
